export default [
    // 注册协议
    {
      path: '/en/agreement/registrationAgreement',
      getComponent(nextState, cb) {
        require.ensure(
          [],
          (require) => {
            cb(null, require('VIEW/agreement/pt/registrationAgreement').default);
          },
          'registrationAgreement',
        );
      },
      onEnter: () => {
        document.body.style.backgroundColor = '#f5f5f9';
      },
    },
    // 有账户协议
    {
      path: '/en/agreement/fastPayAccountAgreement',
      getComponent(nextState, cb) {
        require.ensure(
          [],
          (require) => {
            cb(null, require('VIEW/agreement/en/fastPayAccountAgreement').default);
          },
          'fastPayAccountAgreement',
        );
      },
    },
    // 隐私保护协议
    {
      path: '/en/agreement/privacyProtectionAgreement',
      getComponent(nextState, cb) {
        require.ensure(
          [],
          (require) => {
            cb(
              null,
              require('VIEW/agreement/pt/privacyProtectionAgreement').default,
            );
          },
          'privacyProtectionAgreement',
        );
      },
    },
    {
      path: '/en/agreement/realNameAuthAgreement',
      getComponent(nextState, cb) {
        require.ensure(
          [],
          (require) => {
            cb(null, require('VIEW/agreement/pt/realNameAuth').default);
          },
          'realNameAuthView',
        );
      },
      onEnter: () => {
      },
    },
    {
      path: '/en/agreement/nopwd', //免密支付协议，在服务协议中有
      getComponent(nextState, cb) {
        require.ensure(
          [],
          (require) => {
            cb(null, require('VIEW/agreement/en/noPwd').default);
          },
          'realNameAuthView',
        );
      },
      onEnter: () => {
      },
    },
    {
      path: '/en/agreement/payqrcode', //付款码服务协议
      getComponent(nextState, cb) {
        require.ensure(
          [],
          (require) => {
            cb(null, require('VIEW/agreement/en/payQrCode').default);
          },
          'realNameAuthView',
        );
      },
      onEnter: () => {
      },
    },
  ];
  
  


// WEBPACK FOOTER //
// ./src/route/agreement/en/agreementRedux.js